//@ts-check
import {Button, Loader} from '@/components/atoms'
import {useGetComboDetails} from '@/hooks/productCombo/useGetComboDetails'
import {ProductComboEditor} from '@/pages/ProductCombo/ProductComboEditor'
import {ProductComboSteps} from '@/types/productComboTypes'
import {ROUTES} from '@/utils/constants/routesConstants'
import {transformComboDetailResponse} from '@/utils/productCombo/transformComboDetailResponse'
import {useMemo} from 'react'
import {useNavigate} from 'react-router-dom'

export const ComboDetail = () => {
  const {data, isLoading, error} = useGetComboDetails()
  const navigate = useNavigate()
  const comboData = data?.data
  const comboEditorState = useMemo(
    () =>
      comboData
        ? {
            productCombo: transformComboDetailResponse(comboData),
            currentStep: ProductComboSteps.REVIEW,
          }
        : null,
    [comboData]
  )

  if (isLoading) {
    return (
      <div>
        <Loader />
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex flex-col items-center gap-4">
        <h2>Error loading product combo details</h2>
        <Button
          uiSchema={{title: 'Back to Combo List', size: 'medium', variant: 'primary'}}
          handleButton={() => navigate(ROUTES.PRODUCTS_LIST, {state: {selectedTabNumb: 1}})}
        />
      </div>
    )
  }

  if (!comboData) {
    return (
      <div className="flex flex-col items-center gap-4">
        <h2>No product combo found</h2>
        <Button
          uiSchema={{title: 'Back to Combo List', size: 'medium', variant: 'primary'}}
          handleButton={() => navigate(ROUTES.PRODUCTS_LIST, {state: {selectedTabNumb: 1}})}
        />
      </div>
    )
  }

  return (
    <ProductComboEditor initialState={comboEditorState?.productCombo} initialStep={comboEditorState?.currentStep} />
  )
}
